import fetch from '../utils/fetch'

import { BASE_URL } from './constants'

export const createStagingRecord = (stagingRecord) => {
  return fetch(`${BASE_URL}/staging-area-item/`, {
    method: 'POST',
    body: JSON.stringify(stagingRecord)
  })
}

export const getStagingRecordsByWarehouseId = (warehouseId) => {
  return fetch(`${BASE_URL}/staging-area-item/?warehouseId=${warehouseId}`)
}

export const getStagingRecordsByTrackingNumber = (trackingNumber) => {
  return fetch(`${BASE_URL}/staging-area-item/${trackingNumber}`)
}

export const updateStagingRecordStatus = (trackingNumber, status) => {
  return fetch(`${BASE_URL}/staging-area-item/${trackingNumber}`, {
    method: 'PUT',
    body: JSON.stringify({status})
  })
}



// WEBPACK FOOTER //
// ./src/services/stagingRecordServices.js